import { motion, AnimatePresence } from 'motion/react'
import { OUR_CLIENTS_IMAGES } from '../../../../../constants/ourClients'
// styles
import './styles.css'
// assets

const OurClientsCarousel = () => {
  return (
    <>
      <AnimatePresence mode='wait'>
        <div className='clients-card'>
          <div className='clients-images'>
            {OUR_CLIENTS_IMAGES.map((img, idx) => (
              <motion.img
                key={`clients-${idx}`}
                src={img.src}
                alt={img.alt}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{
                  duration: 1,
                  delay: 0.1 + idx * 0.2,
                }}
              />
            ))}
          </div>
        </div>
      </AnimatePresence>
    </>
  )
}

export default OurClientsCarousel
